export default {
    "id": null,
    "name": "New Cashback Policy",
    "cashbackRate": 0,
    "cashbackExpiryDays": 30,
    "priority": 0,
    "isActive": true,
    
    // Thời gian áp dụng
    "startTime": null,
    "endTime": null,
    "daysOfWeek": null, // "1,2,3,4,5,6,7"
    "timeRanges": null, // "8,9,10,11,12"
    
    // Điều kiện áp dụng
    "userClassifyIds": null, // ",vip,premium,"
    "regionCodes": null, // ",VN,US,JP,"
    "packageIds": null, // ",10,20,30,"
    "userIds": null, // ",user123,user456,"
    "excludeUserIds": null, // ",user150,user250,"
    "billTypes": null, // ",fixrental,payusago,"
    
    // Audit fields
    "createdAt": null,
    "createdBy": null,
    "lastModifiedAt": null,
    "lastModifiedBy": null
}
